import { Observable, TimeoutError, throwError, EMPTY, BehaviorSubject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
// import { ErrorModalComponent } from 'src/app/shared/components/error-modal/error-modal.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Helper } from '../utils/helper';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  bsModalRef: BsModalRef;

  constructor(
    private toasterService: ToastrService,
    private router: Router,
    private authService: AuthService,
    private modalService: BsModalService
  ) { }
  requestApi: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /**
     * @see if method is post also 1st and 2th request @see A both happened then
     * the second request @see A will cancel to avoid duplicate request;
     */
    if (request.method === "POST" && this.requestApi.getValue() == request.url) {
      return EMPTY;
    }

    /**
     * check if request is post will keep the request @see A in memory
    */
    if (request.method === "POST") {
      this.requestApi.next(request.url);
    }

    return next.handle(request)
      .pipe(
        tap((res)=>{
          this.requestApi.next(null);
        }),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status==403) {
              if (request.url.match('prestogateway') && this.router.url.includes('ca-confirm-payment')) {
                // return next.handle(request);
              }else{
                this.toasterService.error("Unauthorized access");
                this.router.navigate(['cit/403-error', { replaceUrl: true }]);
              }
              return throwError(error);
            }
            if (error.status==401) {
              this.logoutUser(request, next)
              return throwError(error);
            }

            if ([400, 500].indexOf(error.status) !== -1) {
              if (request.url.indexOf('/api/tokenauth/authenticate') >= 0) {
                this.toasterService.error(error.error.error.details, error.error.error.message, {positionClass: 'toast-top-center'})
                return throwError(error);
              }

              if (request.url.indexOf('/api/tokenauth/refresh') >= 0) {
                this.logoutUser(request, next);
                return throwError(error);
              }

              if (error.error.error) {
                const err = error.error.error;
                let errorMessage = err.message;
                if (!Helper.isEmpty(err.validationErrors)) {
                  errorMessage+=` ${this.validationMessgae(err.validationErrors)}`
                }

                if (!Helper.isPreventedToast()) {
                  this.toasterService.error(err.details, errorMessage);
                }
                Helper.clearPreventedToast();
              }

              if (error.error.result) {
                const err = error.error.result;
                if (err.errors) {
                  const initialState = { errorKeys: Object.keys(err.errors), errors: err.errors };
                  // this.bsModalRef = this.modalService.show(ErrorModalComponent, { initialState });
                }
              }
            }
            else if (error.status === 404) {
              if (request.url.includes("/uploads")) {
                this.toasterService.error('Not Found!', '404 - File not found');
              }else{
                this.toasterService.error('Not Found!', '404 - API not found');
              }
            }
          }

          else if (error instanceof TimeoutError) {
            this.toasterService.error('API Request Timeout!', 'Timeout');
          }

          return throwError(error);
        })
      );
  }

  validationMessgae(validationErrors){
    let msg = "";
    _.each(validationErrors, (o)=>{
      msg+=`, ${o.message}`;
    });
    return msg;
  }


  private logoutUser(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.toasterService.error("You are logged out please login again with your cred ")
    this.authService.clear();
    this.router.navigate(['/login']);
    return EMPTY;
  }
}
